export default function (response) {
  return response
}



// WEBPACK FOOTER //
// ./src/interceptors/success.js